import { render, staticRenderFns } from "./Position.vue?vue&type=template&id=2b401ceb&"
import script from "./Position.vue?vue&type=script&lang=js&"
export * from "./Position.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports